
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/tab/tab-group.js'
      import type { DdsTabSelectEvent } from '../../events/events'
      export type { DdsTabSelectEvent } from '../../events/events'

      const tagName = 'dap-ds-tab-group'

      /**
 * `dap-ds-tab-group`
 * @summary A tab group component. It is used with dap-ds-tab component to create a tab group.
 * @element dap-ds-tab-group
 * @title - Tab group
 * @group tab
 *
 * @event dds-tab-select - Fired when select a new tab.
 *
 * @slot - The tab items.
 *
 * @csspart base - The main container.
 * @csspart tab-nav - The tab navigation container.
 * @csspart tab-content - The tab content container.
 *
 * @cssproperty --dds-tab-group-border-radius - Border radius of the tab group container (default: var(--dds-radius-base))
 * @cssproperty --dds-tab-border-radius - Border radius for tab items (default: var(--dds-radius-base) var(--dds-radius-base) 0 0)
 * @cssproperty --dds-tab-group-border-width - Border width of the tab navigation (default: var(--dds-border-width-base))
 * @cssproperty --dds-tab-group-border-color - Border color of the tab navigation (default: var(--dds-border-neutral-subtle))
 * @cssproperty --dds-tab-height-sm - Height of small tabs (default: 40px)
 * @cssproperty --dds-tab-height-lg - Height of large tabs (default: 50px)
 * @cssproperty --dds-tab-font-size-sm - Font size of small tabs (default: var(--dds-font-base))
 * @cssproperty --dds-tab-font-size-lg - Font size of large tabs (default: var(--dds-font-lg))
 * @cssproperty --dds-tab-padding - Padding of the tab buttons (default: 0 var(--dds-spacing-400))
 * @cssproperty --dds-tab-border-width - Border width for tabs (default: var(--dds-border-width-large))
 * @cssproperty --dds-tab-selected-border-color - Border color for selected tabs (default: var(--dds-border-brand-base))
 * @cssproperty --dds-tab-text-color - Text color for tabs (default: var(--dds-button-subtle-text-neutral-enabled))
 * @cssproperty --dds-tab-hover-text-color - Text color for tabs on hover (default: var(--dds-text-brand-subtle))
 * @cssproperty --dds-tab-disabled-text-color - Text color for disabled tabs (default: var(--dds-text-neutral-disabled))
 * @cssproperty --dds-tab-hover-background - Background color for tabs on hover (default: var(--dds-transparent-black-subtle))
 * @cssproperty --dds-tab-active-background - Background color for active tabs (default: var(--dds-transparent-black-base))
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsTabSelect: 'dds-tab-select' as EventName<DdsTabSelectEvent>
        },
        displayName: "DapDSTabGroup"
      })

      export default reactWrapper
    